import { DatePipe } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { PageComponent } from './shared/page/page.component';

const routes: Routes = [
  {
    path: '',
    component: PageComponent,
    children: [
      {
        path: '',
        loadChildren: () =>
          import('./pages/pages.module').then((m) => m.PagesModule),
      },
      {
        path: 'booking',
        loadChildren: () =>
          import('./site/booking/booking.module').then((m) => m.BookingModule),
      },
      {
        path: "menu",
        loadChildren: () =>
          import("./pages/shop/shop.module").then((m) => m.ShopModule),
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { anchorScrolling: 'enabled', scrollPositionRestoration: 'enabled' })],

  exports: [RouterModule],
})
export class AppRoutingModule {}
